import { render, staticRenderFns } from "./NoticeBoardList.vue?vue&type=template&id=47f96844&"
import script from "./NoticeBoardList.vue?vue&type=script&lang=ts&"
export * from "./NoticeBoardList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports